import api from './api';

export interface UserCallHistoryParams {
  start_date?: string;
  end_date?: string;
  direction?: string;
  remote_number?: string;
  page?: number;
  per_page?: number;
}

export interface UserCallHistoryResponse {
  success: boolean;
  data: {
    calls: any[];
    pagination: {
      current_page: number;
      per_page: number;
      total: number;
      total_pages: number;
      from: number;
      to: number;
    };
    filters: {
      start_date: string;
      end_date: string;
      extension: string;
      direction: string;
      remote_number: string;
    };
    statistics: any;
  };
}

export interface UserActiveCallsResponse {
  success: boolean;
  data: {
    activeCalls: any[];
    timestamp: string;
  };
}

export interface PresenceResponse {
  success: boolean;
  data: {
    currentUser: {
      id: number;
      member_id: number;
      extension: string;
      custid: string;
      status: string;
      custom_message?: string;
      last_activity: string;
      mem_fname: string;
      mem_lname: string;
      CompanyName: string;
    };
    teamMembers: Array<{
      id: number;
      member_id: number;
      extension: string;
      custid: string;
      status: string;
      actual_status: string;
      custom_message?: string;
      last_activity: string;
      mem_fname: string;
      mem_lname: string;
      CompanyName: string;
      minutes_since_activity: number;
    }>;
    timestamp: string;
  };
}

export interface UpdateStatusResponse {
  success: boolean;
  data: {
    message: string;
    presence: any;
  };
}

class UserPresenceService {
  async getUserCallHistory(params: UserCallHistoryParams): Promise<UserCallHistoryResponse> {
    const response = await api.get<UserCallHistoryResponse>('/endpoints/user-call-history-simple', { params });
    return response.data;
  }

  async getUserActiveCalls(): Promise<UserActiveCallsResponse> {
    const response = await api.get<UserActiveCallsResponse>('/endpoints/user-active-calls');
    return response.data;
  }

  async getPresence(): Promise<PresenceResponse> {
    const response = await api.get<PresenceResponse>('/endpoints/user-presence');
    return response.data;
  }

  async updateStatus(status: string, customMessage?: string): Promise<UpdateStatusResponse> {
    const response = await api.put<UpdateStatusResponse>('/endpoints/user-presence', {
      status,
      custom_message: customMessage
    });
    return response.data;
  }

  async getTeamFilters(): Promise<any> {
    const response = await api.get('/endpoints/team-filters');
    return response.data;
  }
}

const userPresenceService = new UserPresenceService();
export default userPresenceService;